module.exports = __webpack_public_path__ + "img/sign_220140554_1.e7f549c7.png";